import "./EditPartnerDetails.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditPartnerDetailsComponentController from "./EditPartnerDetailsComponentController";

export default class EditPartnerDetailsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditPartnerDetailsComponentController;
        this.templateUrl = "/App/Components/Partners/Details/EditPartnerDetails/EditPartnerDetails.html";
    }
}

module("mmManagePortal").component("irEditPartnerDetails", new EditPartnerDetailsComponent());
